import { OnDestroy, OnInit, Component } from '@angular/core';
import { SubHeader } from '../../../../core/models/sub-header.model';
//import { AllModules, GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";
import { Subscription } from 'rxjs';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { Router } from '@angular/router';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { tap } from 'rxjs/operators'; 
import { AdminReportsService } from '../../../services/admin-reports.service';
import { SuretyBondModel } from '../../../models/admin-reports.model';
import { dateComparator } from "../../../../common/components/data-table/comparators/data-table.comparators";
import { OperationType } from "../../../../common/models/organization.model";

@Component({
    selector: 'app-bonds-report',
    templateUrl: './bonds-report.component.html',
    styleUrls: ['./bonds-report.component.scss'],
    standalone: false
})
export class BondsReportComponent implements OnInit, OnDestroy {

    activeBonds: SuretyBondModel[]
    gridOptions: GridOptions;   
	gridApi?: GridApi
    subHeader: SubHeader = new SubHeader({
        title: "Active Bond Listing",
        buttons: []
    });

    subscription: Subscription = new Subscription();  

    constructor(
        private readonly formatService: GridFormatterService,
        private readonly faService: AdminReportsService,       
        public router: Router,
        public subHeaderService: SubHeaderService
	) { }

    ngOnInit() {
        this.subHeaderService.updateSubHeader(this.subHeader);      
        let coldefs = this.createColumnDefinitions();
        this.gridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);  
        this.gridOptions.suppressColumnVirtualisation = true;
        this.gridOptions.headerHeight = 50;
		this.gridOptions.onGridReady = (params) => { 
            this.gridApi = params.api; 
            this.onGridReady(params);
        };
        this.generateActiveBondsReport();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    

    generateActiveBondsReport() {
        if (this.gridApi) {
            this.gridApi.setGridOption("loading", true);
        }        

        this.subscription = this.faService.getActiveBonds().pipe(
            tap((data) => {
                this.activeBonds = data;
            })).subscribe({
                next: (success) => {
                
                    if (this.gridApi != null) {
                        this.gridApi.setGridOption("rowData",this.activeBonds);
                        this.gridApi.setGridOption("loading", false);             
                        this.gridApi.autoSizeAllColumns();
                    }
                }, 
                error: (fail) => {
                    console.error(fail);
                    if (this.gridApi != null) {
                        this.gridApi.setGridOption("loading", false);
                    }
            }
            });
                
    };

    downloadReport() {
        
        const params = {
            skipHeader: false,
            allColumns: true,
            fileName: `ActiveBondListing`,
            sheetName: "Active Bond",
            exportMode: "xlsx"
        }

        this.formatService.exportDataToExcel(params.fileName, params.sheetName, this.gridApi);
    }    

    public createColumnDefinitions() {
        return [

            {
                headerClass: "wrapped",
                headerName: "Owner",
                headerTooltip: "Owner",
                field: "ownerName",
                tooltipField: 'ownerName',                   
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams, 
                minWidth: 150,
                maxWidth: 200
            },
            {
                headerClass: "wrapped",
                headerName: "RICS Owner #",
                headerTooltip: "RICS Owner #",
                field: "ricsOwnerNumber",
                tooltipField: 'ricsOwnerNumber',               
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                maxWidth: 140,
                minWidth: 140
            },    
            {
                headerClass: "wrapped",
                headerName: "RBDMS Owner #",
                headerTooltip: "RBDMS Owner #",
                field: "rbdmsOwnerNumber",
                tooltipField: "rbdmsOwnerNumber",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                maxWidth: 140,
                minWidth: 140
            },
            {
                headerClass: "wrapped",
                headerName: "Owner Type",
                headerTooltip: "Owner Type",
                tooltipValueGetter: this.formatOwnerType(),
                valueGetter: this.formatOwnerType(),
                minWidth: 110,
                maxWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Bond Number",
                headerTooltip: "Bond Number",
                field: "instrumentId",
                tooltipField: "instrumentId",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 125,
                maxWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Amount",
                headerTooltip: "Amount",
                field: "amount",
                tooltipValueGetter: this.formatService.formatCurrency("amount", "USD", "symbol", "1.2-2"),
                valueFormatter: this.formatService.formatCurrency("amount", "USD", "symbol", "1.2-2"),               
                filter: "agNumberColumnFilter",
                filterParams: this.formatService.defaultNumberFilterParams,
                minWidth: 125,
                maxWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Type of Bond Instrument",
                headerTooltip: "Type of Bond Instrument",
                field: "bondInstrumentType",
                tooltipField: 'bondInstrumentType',                
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 125,
                maxWidth: 175
            },
            {
                headerClass: "wrapped",
                headerName: "Guarantor",
                headerTooltip: "Guarantor",
                field: "guarantor",
                tooltipField: "guarantor",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 150,
                maxWidth: 200
            },
            {
                headerClass: "wrapped",
                headerName: "Expiration Date",
                headerTooltip: "Expiration Date",
                field: "expirationDate",
                tooltipValueGetter: this.formatService.formatDate("expirationDate"),
                valueFormatter: this.formatService.formatDate("expirationDate"),
                filter: "agDateColumnFilter",
                filterParams: this.formatService.defaultDateFilterParams,
                minWidth: 125,
                maxWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Maturity Date",
                headerTooltip: "Maturity Date",
                field: "maturityDate",
                tooltipValueGetter: this.formatService.formatDate("maturityDate"),
                valueFormatter: this.formatService.formatDate("maturityDate"),
                filter: "agDateColumnFilter",
                filterParams: this.formatService.defaultDateFilterParams,
                minWidth: 125,
                maxWidth: 150
            }
                     
        ] as ColDef[];
    }

    formatOwnerType(): any {
        return (obj: any) => {
            let returnValue: string = "";
            if (obj.data != null && obj.data["ownerType"] != null) {
                let isBrineHaulerFunc = this.formatService.flagEnumFormatter("ownerType", OperationType, "BrineHauler", true);
                let isOperatorFunc = (this.formatService.flagEnumFormatter("ownerType", OperationType, "Operator", true));
                let isInjectionOperatorFunc = (this.formatService.flagEnumFormatter("ownerType", OperationType, "InjectionOperator", true));
                if (isBrineHaulerFunc(obj) == true) {
                    returnValue = "Brine Hauler";
                }
                if (isOperatorFunc(obj) == true || isInjectionOperatorFunc(obj) == true) {
                    if (returnValue.length > 0) returnValue += ", ";
                    returnValue += "Well Owner";
                }
            }
            if (returnValue.length === 0) returnValue = "N/A";
            return returnValue;
        }
    }

    onGridReady(event: any) {
        this.formatService.gridReadyAutoSizeColumns(event);
    }

}
